<template>
  <eden-filter
    :width="270"
    :properties.sync="properties"
    :disabled="disabled"
    :loading="loading"
    @open="getData"
    @reset="reset"
    @filter="filter"
  />
</template>

<script>
import * as actions from "@/store/action-types";

export default {
  name: "OrdersFilter",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      properties: {
        status: {
          key: "status",
          label: "Status",
          type: "list",
          options: [
            {
              label: "Complete",
              value: "complete",
            },
            {
              label: "Incomplete",
              value: "incomplete",
            },
          ],
          value: [],
        },
        order_type: {
          key: "order_type",
          label: "Order Type",
          type: "list",
          options: [
            {
              label: "Subscription",
              value: "subscription",
            },
            {
              label: "One-time",
              value: "one-time",
            },
          ],
          value: [],
        },
        period: {
          key: "period",
          label: "Period",
          type: "list",
          options: [
            {
              label: "Last week",
              value: "lastweek",
            },
            {
              label: "Yesterday",
              value: "yesterday",
            },
            {
              label: "Today",
              value: "today",
            },
            {
              label: "Tomorrow",
              value: "tomorrow",
            },
            {
              label: "This week",
              value: "thisweek",
            },
            {
              label: "Next week",
              value: "nextweek",
            },
          ],
          value: [],
        },
        service: {
          key: "service",
          label: "Services",
          type: "list",
          options: [],
          value: [],
        },
        gardener: {
          key: "gardener_id",
          label: "Gardener",
          type: "list",
          options: [],
          value: [],
          searchable: true,
        },
      },
    };
  },
  computed: {
    gardeners() {
      return this.$store.getters.gardeners_list;
    },
    services() {
      return this.$store.getters.services;
    },
    zones() {
      return this.$store.getters.zones_list;
    },
  },
  watch: {
    clear() {
      if (this.clear) {
        this.reset();
      }
    },
  },
  methods: {
    getData() {
      this.getGardeners();
      this.setServices();
    },
    getGardeners() {
      if (this.properties.gardener.options.length) {
        this.loading = false;
        return;
      }

      this.gardeners.length
        ? this.setGardenerOptions()
        : this.$store.dispatch(actions.GET_GARDENERS_LIST).then(() => {
            this.setGardenerOptions();
          });
    },
    setGardenerOptions() {
      this.properties.gardener.options = this.gardeners.map((gardener) => {
        return {
          label: this.formatName(gardener.name),
          value: gardener.id,
        };
      });
      this.loading = false;
    },
    setServices() {
      this.properties.service.options = this.services.map((service) => {
        return {
          label: this.formatText(service.service_name),
          value: service.service_name.toLowerCase(),
        };
      });
    },
    reset() {
      Object.keys(this.properties).forEach((key) => {
        this.properties[key].value = [];
      });
    },
    filter() {
      let params = {
        params: {},
        paramsLabel: {},
      };

      Object.keys(this.properties).forEach((property) => {
        const { key, type, value } = this.properties[property];
        if (value && value.length) {
          switch (type) {
            case "list":
              params.params[key] = value[0];
              params.paramsLabel[key] = this.properties[property];
              break;
            case "daterange":
              params.params[key[0]] = this.properties[property].value[0];
              params.params[key[1]] = this.properties[property].value[1];
              params.paramsLabel[key] = this.properties[property];
              break;
            default:
              break;
          }
        }
      });

      if (Object.keys(params.params).length) {
        this.$emit("filter", {
          params: params.params,
          paramsLabel: params.paramsLabel,
        });
      } else {
        this.$message.info("Filtering requires at least one property");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
